/* eslint-disable */
import React, {useEffect, useState} from 'react'
import { useLocation } from "react-router-dom";
import moment from 'moment';
// import _ from 'lodash';
import Divider from "components/Divider";
import Svg from "_assets/svg";
import styled from 'styled-components';
const Icon = styled.img``;

import Modal from 'react-modal';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px',
  },
};

// servicess
// import manageChannelManagement from 'services/managementChannelSvc';
import applicationSvc from 'services/applicationSvc';

// components
import BreadCrumb from 'components/BreadCrumb';
import { Alert } from 'utils/Alert';
import TextInput from 'components/TextInput';
import Dropdown from "./Dropdown";
// import Table from './TableData'
import RemainingQuota from "../RemainingQuota";

// style
import './detailApp.scss';
import { dataTokenChannel, listChannel } from './dataSupportDetail';

const ButtonProject = styled.div`
  /* Rectangle 99 */
  // margin: 8px;

  // padding: 10px;
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background: #f8f8f9;
  opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus{
    outline: none;
  }

  width: 100%;
  min-width: 300px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  cursor:pointer;
`;

function DetailAppNew() {
  const [isDataDetail, setDataDetail] = useState()
  const [loadingGenerate, SetLoadingGenerate] = useState(false)
  const [isSelectedChannel, setSelectedChannel] = useState('');
  const [dropdown, setDropdown] = useState(false);
  const [isLoadingGetList, setLoadingGetList] = useState(false)
  // const [isDataUser, setDataUser] = useState([])
  const [openModalGenerateToken, setOpenModalGenerateToken] = useState(false)
  const location = useLocation();

  const [isBreadcrumb, setBreadcrumb] = useState(
    [
      {
        name: 'My Application',
        link: '/my-application',
      },
      {
        name: 'Details App',
        link: '',
      },
    ]
  );



  useEffect(() => {
    setDataDetail(location?.state?.dataDetailApp);
    // getPhoneNumberById(location?.state?.dataDetailApp);
    isBreadcrumb[1].name = location?.state?.dataDetailApp?.application_name;
    getDataById(location?.state?.dataDetailApp?._id);
    setBreadcrumb(isBreadcrumb)
  }, [location]);

  function handleSelectedChannel(i) {
    if(!i.disabled) {
      setSelectedChannel(i); 
      setDropdown(false);
    }
  }

  // function lastUpdate() {
  //   let result;
  //   if (location?.state?.dataDetailApp) {
  //     const sortedData = _.sortBy(location?.state?.dataDetailApp, ['updated_at']);
  //     const lastUpdatedDate =
  //       sortedData?.updated_at !== null ? sortedData.updated_at : sortedData.created_at;
  //     result = moment(lastUpdatedDate).fromNow();
  //   } else {
  //     result = 'No data';
  //   }
  //   return result;
  // }

   // Integration
  // const getPhoneNumberById = async (dataLocation) =>{
  //   setLoadingGetList(true)
    
  //   if(dataLocation){
  //     try {
  //       const dataManage = await manageChannelManagement.getLisPhoneNumbertByApp(dataLocation?._id)
  //       setDataUser(dataManage.data)
  //       setLoadingGetList(false)
  //     } catch (error) {
  //         Alert.showStatus(
  //           'error',
  //           'Error',
  //           error?.message
  //         )
  //       setLoadingGetList(false)
  //     }
  //   }
  // } 


  async function onGenerateKey(){
    SetLoadingGenerate(true)
    try {
      const channelId = isSelectedChannel.dataChannel._id;
      const reqBody = {
        application: isSelectedChannel.dataChannel.application_id
      }
      const privateKey = await applicationSvc.generateToken(channelId, reqBody);
      downloadPem(privateKey.data, location?.state?.dataDetailApp._id);

      getDataById(location?.state?.dataDetailApp?._id);
      Alert.showStatus(
        'success',
        'Success Generate Token',
        'Check your downloaded file'
      )
    } catch (err) {
      Alert.showStatus(
        'error',
        'Failed to Generate Key',
        'There was a problem connecting to our server. Try generating key again in a few minutes.'
      )
    } finally {
      setOpenModalGenerateToken(false)
      SetLoadingGenerate(false)
    }
  }

  const downloadPem = (text, appId) => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `${appId}.txt`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }

  async function getDataById(id){
    setLoadingGetList(true);
    if(id){
      try {
        const applicationData = await applicationSvc.getById(id);
        if(applicationData.data.data.channels.length > 0) {
          dataTokenChannel.forEach((element) => {
            applicationData.data.data.channels.forEach((item) => {
              const dataChannel = item?.channelData ? item?.channelData[0]?.code : item.channel.code;
              if(element.value === dataChannel){
                element.access_token = item.access_token;
              }
            })
          })

          listChannel.forEach((element) => {
            applicationData.data.data.channels.forEach((item) => {
              const dataChannel = item?.channelData ? item?.channelData[0]?.code : item.channel.code;
              if(element.value === dataChannel){
                element.dataChannel = item;
              }
            })
          })
        }
        setLoadingGetList(false);
      } catch (err) {
        setLoadingGetList(false);
      }
    }
  };

  const revokeToken = (data) => {
    console.log('datas', data)
    if(data === null || data === undefined) return;
    switch (data.is_revoke) {
      case true:
        return 'inactive'
        break;

      case false:
        return 'active'
        break;

      case null:
        return ''
        break;
    
      default:
        break;
    }
  }
  
  return (
    <div className='container_detail_application'>
      <div className='wrapper_title mb-4'>
        <h3 className='title_custom_700'>Details App</h3>
        <div className='d-flex align-items-center w-100'>
          <BreadCrumb dataBreadCrumb={isBreadcrumb} />
          <div className='d-flex align-items-center fsize-14 fweight-500 cl-grey-deep ms-2'>
            <span>Last Modified :</span> 
            <span className='ms-2'> 
              {moment(isDataDetail?.updated_at).format('DD MMMM YYYY')}
            </span>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <div className='form-group'>
            <label className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2'>Application Name</label>
            <label className='fsize-14 fweight-400 cl-neutral400 mb-2 ltr-spaccing-2'>Give a friendly identifier to your application.</label>
            <TextInput 
              className='cl-neutral600 fsize-14 fweight-400 mb-1'
              value={isDataDetail?.application_name}
              disabled
            />
          </div>
        </div>
        <div className='col-sm-12 col-md-6'>
          <div className='form-group'>
            <label className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2'>App ID</label>
            <label className='fsize-14 fweight-400 cl-neutral400 mb-2 ltr-spaccing-2'>Your own App ID, as an identifier.</label>
            <TextInput 
              className='cl-neutral600 fsize-14 fweight-400 mb-1'
              value={isDataDetail?._id}
              disabled
            />
          </div>
        </div>
      </div>
      <div className='auth_token mb-4'>
        <label className='fsize-16 fweight-600 cl-neutral400 d-block mb-1 ltr-spaccing-2'>Token Authentication</label>
        <label className='fsize-14 fweight-400 cl-neutral400 mb-3 ltr-spaccing-2'>
          OCA APIs (Voice, Messages, Conversation, etc) use JSON Web Tokens (JWTs) for authentication. The JWTs must be signed with the private key of this application. 
          <br />
        </label>
        <div className='d-flex align-items-center'>
          <div className='position-relative me-3'>
            <ButtonProject className="w-auto col-md-6 br-8" onClick={() => { setDropdown(!dropdown) }}>
              <label className="margin-right-10">{isSelectedChannel ? isSelectedChannel.name :'Pick a channel to generate'}</label>
              <Icon src={Svg.chevron_right_2.default} />
            </ButtonProject>
            {dropdown && <Dropdown data={listChannel} handleClick={(i) => handleSelectedChannel(i)} />}
          </div>
          <button disabled={loadingGenerate || !isSelectedChannel} onClick={()=> setOpenModalGenerateToken(true)} className='btn_generate_token'>
              Generate
          </button>
        </div>
       
       <div className='d-flex flex-wrap items-center mt-4'>
        {dataTokenChannel.map((item, index) => {
          return (
              <div 
                className={`box_token ${revokeToken(item?.access_token)}`} 
                key={index}
              >
                <label className='fsize-14 fweight-600 color-grey d-block'>{item.name}</label>
                <label className='fsize-14 fweight-600 color-grey mb-3 d-block'>{item.tokenDesc}</label>
                {item?.access_token !== null ? (
                  <label className={`status ${revokeToken(item?.access_token)} fsize-12 fweight-700 cl-grey-light mb-3 d-block`}>{item?.access_token?.is_revoke ? 'InActive' : 'Active'}</label>
                ) : (
                  <label className='status fsize-12 fweight-700 cl-grey-light mb-3 d-block'>{item.status}</label>
                )}
                <label className='fsize-9 fweight-400 cl-grey-light d-block'>
                  <span>Last Generated : </span>  
                  <span className='ms-0'>
                    {
                      item?.access_token ? 
                        moment(item?.access_token?.updated_at).format('DD/MM/YYYY HH:mm') 
                        : 
                      '-'
                    }
                  </span>
                </label>
              </div>
            )
          })}
          </div>
      </div>
      <Divider className="margin-bottom-15" />
      
      <RemainingQuota applicationID={location?.state?.dataDetailApp?._id} /> 
      {/* <div className='wrapper_table_detail_app'>
        <h3 className='fsize-16 fweight-600 cl-neutral400 d-block ltr-spaccing-2 mb-3'>Link to channels </h3>
        <div>
          <Table 
            isLoadingGetList={isLoadingGetList} 
            isDataUser={isDataUser}
          />
        </div>
        <span className='cl-grey fweight-400'>
          You can set up your channel’s accounts on 
          <Link to='/management-channel' className='cl-red cursor-pointer text-decoration-none ms-1'>
            Channel Management
          </Link>
        </span>
      </div> */}

      <Modal
        isOpen={openModalGenerateToken}
        onRequestClose={openModalGenerateToken}
        style={customStyles}
        contentLabel="modal generate token"
      >
        <div className='d-flex justify-content-between flex-column text-center' style={{height:'unset',width:'370px'}}>
          <label className='fsize-16 fweight-600 color-grey mb-3'>Generate Key for {isSelectedChannel.name}?</label>
          <label className='fsize-12 fweight-400 cl-neutral400 mb-4'>Save the downloaded file with the JWT and private key somewhere safe. The keys will not be shown again.</label>
        
          <div className='d-flex align-items-center justify-content-around'>
            <button disabled={loadingGenerate} onClick={()=> setOpenModalGenerateToken(false)} className='w-50 me-3 btn_generate_secondary'>
              Cancel
            </button>
            <button disabled={loadingGenerate} onClick={onGenerateKey} className='w-50 btn_generate_token'>
              Yes, Generate Key
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default DetailAppNew